import CONFIG from 'Config';
import BaseHSFormModel from './BaseHSFormModel';

const params = {
  email: {
    type: 'email',
    validate: {
      email: 'Email',
      minLength: 5,
      required: true,
    },
  },
};

export default class SubscribeNewsletterModel extends BaseHSFormModel {
  constructor() {
    super();

    this.$messageSuccess = 'Subscribed';
    this.$scrollTopOnSuccess = false;
    this.$gtmEvent = 'at.generalSubscriber.footer';
    this.$hsFormId = CONFIG.hubspotFormIds.subscribeNewsletter;
    this.$formName = 'Subscribe Newsletter';
    this._setParams(params);
  }
}
